import {
  AdvancedSearchFieldConfig,
  AdvancedSearchFormField,
  SearchOperator,
  StringFieldSearchConfig,
  SubmitableSortField,
  SubmittableSearchFormField,
} from "@/config/forms/advanced-search/advanced-search-fields-def";
import { Overwrite } from "@/lib/utils";
import { createContext, Dispatch, SetStateAction, useContext } from "react";

export type AdvancedSearchContextQueryData = {
  fields: SubmittableSearchFormField[];
  searchMode: SearchOperator;
  name?: string;
};

type AdvancedSearchContextType = {
  // enables to get metadata, usefull for the chip or the form state
  advancedSearchQuery: AdvancedSearchContextQueryData | undefined;
  // used by the form
  setAdvancedSearchQuery: (
    newQuery:
      | Overwrite<
          AdvancedSearchContextQueryData,
          { fields: AdvancedSearchFormField[] }
        >
      | undefined,
  ) => void;
  resetQuery: () => void;

  sortFields?: SubmitableSortField[];
  setSortFields: (sortFields: SubmitableSortField[]) => void;
  resetSortFields: () => void;

  // used by GlobalSearch
  setGlobalSearch: Dispatch<
    SetStateAction<{
      searchContent: string;
      stringConfig: AdvancedSearchFieldConfig<StringFieldSearchConfig>[];
    }>
  >;
  globalSearch: string;

  // enables to get the actual prisma request, used by the dashboard
  prismaWhereQueryContent: object;

  prismaOrderByQueryContent: object[];
};

export const AdvancedSearchContext = createContext<
  AdvancedSearchContextType | undefined
>(undefined);

export const useAdvancedSearch = () => {
  const context = useContext(AdvancedSearchContext);
  if (!context)
    throw new Error(
      "useAdvancedSearch must be used within an AdvancedSearchProvider",
    );
  return context;
};
